class HeaderSpaceAdjuster {
    constructor() {
        this.viewport = this.updateViewportDimensions();
        this.timeToWaitForLast = 100; // Time to throttle window resize events
        this.initEvents();
    }

    initEvents() {
        document.addEventListener('DOMContentLoaded', () => {
            this.headerSpaceFix();

            window.addEventListener('load', () => {
                this.viewport = this.updateViewportDimensions();
                this.headerSpaceFix();
            });
        });

        // Throttled resize event
        window.addEventListener('resize', () => {
            this.waitForFinalEvent(() => {
                this.viewport = this.updateViewportDimensions();
                this.headerSpaceFix();
            }, this.timeToWaitForLast, "resizeElementsIdentifierString");
        });
    }

    headerSpaceFix() {
        requestAnimationFrame(() => {
            const headerEl = document.querySelector('.site-header');
            if (!headerEl) {
                return;
            }

            const rect = headerEl.getBoundingClientRect();
            const styles = window.getComputedStyle(headerEl);
            const marginTop = parseFloat(styles.marginTop) || 0;
            const marginBottom = parseFloat(styles.marginBottom) || 0;
            const headerHeight = rect.height + marginTop + marginBottom;

            if (headerHeight > 0) {
                document.querySelectorAll('.header-space-fix').forEach((el) => {
                    el.style.height = `${headerHeight}px`;
                });

                const menuTop = this.viewport.width < 782 ? `${headerHeight}px` : '0px';
                document.querySelectorAll('ul.menu-main').forEach((el) => {
                    el.style.top = menuTop;
                });
            }
        });
    }

    updateViewportDimensions() {
        const w = window, d = document, e = d.documentElement, g = d.getElementsByTagName('body')[0];
        const x = w.innerWidth || e.clientWidth || g.clientWidth;
        const y = w.innerHeight || e.clientHeight || g.clientHeight;
        return { width: x, height: y };
    }

    waitForFinalEvent(callback, ms, uniqueId) {
        if (!this.timers) {
            this.timers = {};
        }
        if (this.timers[uniqueId]) {
            clearTimeout(this.timers[uniqueId]);
        }
        this.timers[uniqueId] = setTimeout(callback, ms);
    }
}

new HeaderSpaceAdjuster();
